 <template>
  <v-dialog
    :value="value"
    persistent
    max-width="500px">
      <v-system-bar color="primary" dark dense>
        <span class="white--text">Конфигурация {{project ? project.ULF_NAME : ''}} ({{project ? project.STATE.DS_NAME : ''}})</span>
        <v-spacer></v-spacer>
        <v-icon @click="doCancel" color="white">mdi-close</v-icon>
      </v-system-bar>
      <v-card>
        <v-card-title class="headline">
          Перевести в статус:
        </v-card-title>
        <v-card-text class=" black--text">
          <v-select
            :items="projectStatusItems"
            item-text="NEXT_STATE_NAME"
            item-value="SIGNAL_ID"
            label="Доступные статусы"
            v-model="nextStatus"
            return-object
            no-data-text="Нет доступных действий"
            dense
          ></v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="secondary"
            outlined
            @click="doCancel"
          >
            Отмена
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            :disabled="!sendActive"
            @click="doOK"
          >
            Изменить статус конфигурации
          </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>

import { RCPT_POST_STATE } from '@/store/actions/receptures'
import { UI_ERROR, UI_REQUEST, UI_SNACKBAR, UI_SUCCESS } from '@/store/actions/ui'
import axios from 'axios'

export default {
  name: 'prjActionDialog',
  data () {
    return {
      nextStatus: {},
      projectStatusItems: []
    }
  },
  props: ['value', 'project'],
  watch: {
    project (val) {
      if (val) {
        this.getAvlStatuses()
      }
    }
  },
  computed: {
    sendActive: {
      get: function () {
        return ('SIGNAL_ID' in this.nextStatus)
      }
    }
  },
  methods: {
    getAvlStatuses () {
      const payload = {
        ULF_ID: this.project.ULF_ID
      }
      this.$store.dispatch(UI_REQUEST, { action: 'LOCAL_ACTION', topic: 'Запрос данных', error: null })
      axios({ url: '/api/org/receptures/rcptGetAvlStatuses.php', data: payload, method: 'POST' })
        .then(resp => {
          console.log('Statuses got', resp.data.data)
          if (resp.data.error === 'ok') {
            this.projectStatusItems.splice(0, this.projectStatusItems.length, ...resp.data.data)
            this.$store.dispatch(UI_SUCCESS, { action: 'LOCAL_ACTION' })
          } else {
            this.$store.dispatch(UI_ERROR, { action: 'LOCAL_ACTION', result: resp.data.error_text })
          }
        })
        .catch((err) => {
          console.log('Server error ', err)
          this.$store.dispatch(UI_ERROR, { action: 'LOCAL_ACTION', result: err })
        })
    },
    doOK () {
      console.log('Confirmed status ', this.nextStatus)
      this.$store.dispatch(
        RCPT_POST_STATE,
        { PTC: 'state', ULF_ID: this.project.ULF_ID, DS_ID: this.project.STATE.DS_ID, SIGNAL_ID: this.nextStatus.SIGNAL_ID }
      )
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка обновления данных: \n ${err}` })
        })
      this.nextStatus = {}
      this.$emit('input', false)
    },
    doCancel () {
      this.nextStatus = {}
      this.$emit('input', false)
    }
  },
  mounted: function () {
    console.log('Config action dialog mounted')
    if (this.project) this.getAvlStatuses()
  }

}
</script>
